import { createAppStore } from '@shared/app/BaseAppStore';
import { manifest } from './manifest';

/** Create a unique Zustand store instance for this app */
export const useAppStore = createAppStore(manifest.uuid);
